<!-- role="switch" + Space/Enter so the switch is reachable and operable from the keyboard
     (WAI-ARIA switch pattern); the house :focus-visible ring (base.scss) marks keyboard focus.
     appearance="neumorphic" is the DS 2.1 switch: a 52x32 sunken well with a raised 26px knob. The empty span widens the hit area to 48px tall for touch. -->
<div
  role="switch"
  class="tw-relative tw-w-[52px]"
  [class.tw-h-6]="!neumorphic"
  [class.tw-rounded-xl]="!neumorphic"
  [class.tw-p-1]="!neumorphic"
  [class.tw-h-8]="neumorphic"
  [class.tw-rounded-full]="neumorphic"
  [class.tw-shadow-elevation-input]="neumorphic"
  [class.tw-cursor-pointer]="!disabled"
  [class.tw-cursor-not-allowed]="disabled"
  [attr.tabindex]="disabled ? -1 : 0"
  [attr.aria-checked]="isEnabled"
  [attr.aria-disabled]="disabled || null"
  [attr.aria-label]="ariaLabel"
  [class.tw-shadow-inner]="!neumorphic && (!isEnabled || colorVariant === 'default')"
  [ngClass]="
    neumorphic
      ? {
          'tw-bg-color-surface-input': !isEnabled,
          'tw-bg-color-action-primary': isEnabled,
        }
      : {
          'tw-bg-neutral-300': !isEnabled,
          'tw-bg-dt-custom-teal-9': isEnabled && colorVariant === 'default',
          'tw-bg-success-600': isEnabled && colorVariant === 'success',
        }
  "
  (click)="onToggleClick()"
  (keydown.space)="onToggleKey($event)"
  (keydown.enter)="onToggleKey($event)"
>
  @if (neumorphic) {
    <span class="tw-absolute -tw-inset-x-1 -tw-inset-y-2" aria-hidden="true"></span>
    <div
      class="tw-absolute tw-top-[3px] tw-z-10 tw-h-[26px] tw-w-[26px] tw-rounded-full tw-bg-color-surface-card tw-shadow-elevation-control"
      [class.tw-left-[3px]]="!isEnabled"
      [class.tw-left-[23px]]="isEnabled"
    ></div>
  } @else {
    <div
      class="tw-absolute tw-z-10 tw-h-4 tw-w-4 tw-rounded-full tw-bg-light"
      [class.tw-left-[34px]]="isEnabled"
    ></div>
  }
</div>
